import { render } from "./setting.vue?vue&type=template&id=03fbfb7a&scoped=true"
import script from "./setting.vue?vue&type=script&lang=js"
export * from "./setting.vue?vue&type=script&lang=js"

import "./setting.vue?vue&type=style&index=0&id=03fbfb7a&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fbfb7a"]])

export default __exports__